import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';
import { useI18n } from '@/contexts/I18nContext';

interface FaqAccordionProps {
  faq: { q: string; a: string }[];
}

/** Static, role-aware FAQ list rendered as a collapsible accordion. */
export function FaqAccordion({ faq }: FaqAccordionProps) {
  const { tp } = useI18n();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">{tp.support.faqTitle}</CardTitle>
      </CardHeader>
      <CardContent>
        <Accordion type="single" collapsible className="w-full">
          {faq.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger className="text-start text-sm font-medium">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </CardContent>
    </Card>
  );
}
